import * as userRequest from "@/utils/userRequest";

export default async function checkEmailAuthenticationService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("auth/check-authen", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log("🚀 ~ checkEmailAuthenticationService res:", res);
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ checkEmailAuthenticationService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
